import { useState } from 'react';

import { OutgoingProductCheckoutSessionDto } from 'api/dtos/products/checkout';

/**
 * Manages the value of the special code entered by the user.
 * A special code can be a discount code.
 * This hook is only handling the code itself (ie: value of the special code field in the UI).
 * Discount data is handled in the checkout session response.
 */
const useSpecialCode = () => {
  const [code, setCode] = useState<string | null>(null);
  const [discountCode, setDiscountCode] = useState<string | null>(null);

  /**
   * Applies a discount code
   */
  const applyDiscountCode = (
    code: string,
    checkoutUpdater?: (
      code: string
    ) => Promise<OutgoingProductCheckoutSessionDto>
  ) => {
    if (checkoutUpdater) {
      checkoutUpdater(code).then(() => setDiscountCode(code));
    } else {
      setDiscountCode(code);
    }
  };

  return {
    discountCode: { value: discountCode, applyDiscountCode },
    code: { value: code, setCode }
  };
};

export default useSpecialCode;
